import React, { useState, useEffect } from "react";
import {
    Box,
    Paper,
    BottomNavigation,
    BottomNavigationAction,
    Typography,
    ListItemButton,
    IconButton
} from "@mui/material";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatIcon from "@mui/icons-material/Chat";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import CachedIcon from "@mui/icons-material/Cached";
import heartsBg from "./hearts4.png";
import heartsBg2 from "./hearts4.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";

export default function Activity() {
    const [tab, setTab] = useState(1);
    const navigate = useNavigate();
    const [conversation, setConversation] = useState({
        liked: 0,
        likes: 0,
        super_likes: 0,
        matches: 0,
    });

    const refetchStats = async () => {
    toast.success("Refreshing page...", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    fetchMatches();
  };

    const fetchMatches = async () => {
        try {
            const { token } = JSON.parse(localStorage.getItem("userSessionData"));
            const res = await axios.get(`${apilink.link}/statistics-data`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log(res.data);
            setConversation({
                liked: res.data.liked_by_me,
                likes: res.data.liked_me,
                super_likes: res.data.superliked_me,
                matches: res.data.my_matches,
            });
        } catch (err) {
            console.error(err.response?.data || err.message);
            alert("Failed to load matches");
        }
    };

    useEffect(() => {
        fetchMatches();
    }, []);

    return (
        <Box sx={{ minHeight: "100vh", bgcolor: "#fff7f8", pb: 12 }}>

            {/* 🔝 Sticky Top Bar */}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 20,
                    backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.7), rgba(255,255,255,0.9)),
                    url(${heartsBg})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    p: 2,
                    borderBottom: "1px solid #eee",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Typography variant="h6" fontWeight="bold">
                    Connections
                </Typography>
                <IconButton onClick={() => refetchStats()}>
                    <CachedIcon />
                </IconButton>
            </Box>

            {/* ✅ Activity Hub */}
            <Box sx={{ p: 2 }}>

                {/* Activity Tiles */}
                {[
                    { label: "Liked", count: conversation.liked, path: "/liked" },
                    { label: "Likes", count: conversation.likes, path: "/likes" },
                    { label: "Super Likes", count: conversation.super_likes, path: "/views" },
                    { label: "Matches", count: conversation.matches, path: "/matches" },
                    { label: "Super Connect", count: 0, path: "/super-connect" },
                ].map((item, i) => (
                    <Box
                        key={i}
                        sx={{
                            mb: 1.5, // ✅ Space between each tile
                            borderRadius: 3,
                            bgcolor: "#fff",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                            overflow: "hidden",
                        }}
                    >
                        <ListItemButton
                            onClick={() => navigate(item.path)}
                            sx={{
                                py: 1.7,
                                px: 2,
                                display: "flex",
                                justifyContent: "space-between",
                            }}
                        >
                            {/* Left Text */}
                            <Typography fontWeight="600" fontSize={15}>
                                {item.label}
                            </Typography>

                            {/* Right Side */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                {/* Count Bubble */}
                                {item.label !== "Super Connect" && <>
                                    <Box
                                        sx={{
                                            minWidth: 30,
                                            height: 22,
                                            px: 1,
                                            borderRadius: 99,
                                            bgcolor: "#ffe5e7",
                                            color: "#010832",
                                            fontSize: 13,
                                            fontWeight: "bold",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {item.count}
                                    </Box>

                                </>}

                                {/* Arrow */}
                                <Typography sx={{ color: "#bbb", fontSize: 20 }}>
                                    ›
                                </Typography>
                            </Box>
                        </ListItemButton>
                    </Box>
                ))}
            </Box>

            {/* Bottom Navigation */}
            <Paper elevation={6} sx={tabStyle}>
                <BottomNavigation
                    sx={{
                        height: 66,
                        paddingTop: "6px",
                        paddingBottom: "6px",
                        borderRadius: "10px",
                        backgroundImage: `
                    linear-gradient(to right, rgba(255,255,255,0.9), rgba(255,255,255,0.7)),
                    url(${heartsBg2})
                    `,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        "& .MuiBottomNavigationAction-root": {
                            color: "#999", // inactive
                        },
                        "& .MuiBottomNavigationAction-root.Mui-selected": {
                            color: "#010832", // active icon + label
                        },
                    }}
                    value={tab}
                    onChange={(e, v) => {
                        setTab(v);
                        if (v === 0) navigate("/discover");
                        if (v === 2) navigate("/chats");
                        if (v === 3) navigate("/profile");
                    }}
                    showLabels
                >
                    <BottomNavigationAction label="Explore" icon={<WhatshotIcon />} />
                    <BottomNavigationAction label="Connections" icon={<FavoriteIcon />} />
                    <BottomNavigationAction label="Chats" icon={<ChatIcon />} />
                    <BottomNavigationAction label="Profile" icon={<PersonIcon />} />
                </BottomNavigation>
            </Paper>
            <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
        </Box>
    );


}

const tabStyle = {
    position: "fixed",
    bottom: 12,
    left: "50%",
    transform: "translateX(-50%)",
    width: "calc(100% - 24px)",
    maxWidth: 420,
    borderRadius: 8,
};
